import React, { useEffect, useState } from 'react';
import './App.css';
import bgImage from './assets/bg12.svg';
import AirportModal from './components/AirportModal';
import { AirportProvider, useAirport } from './context/AirportContext';
import { Airport } from './interfaces/airport';
import HomePage from './pages/HomePage';

// Inner shell so we can access context inside App tree
function AppShell() {
  const { airportId, setAirportId } = useAirport();
  const [airportName, setAirportName] = useState<string>("");
  const [openPicker, setOpenPicker] = useState(true); // open on every refresh

  // optional: force modal to open if airportId not chosen yet
  useEffect(() => {
    if (!airportId) setOpenPicker(true);
  }, [airportId]);

  return (
    <div className="App h-screen w-screen" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover' }}>
      {/* Your existing app */}
      <HomePage openAirportPopup={() => setOpenPicker(true)} airportName={airportName} /> 

      {/* Airport picker always opens on refresh */}
      <AirportModal
        open={openPicker}
        onClose={() => setOpenPicker(false)}
        onSelect={(airport: Airport) => {
          setAirportId(airport._id);
          setAirportName(airport.name);
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <AirportProvider>
      <AppShell />
    </AirportProvider>
  );
}
